import React from 'react';
import { OutlinePhoneIcon } from '@tempmee/react-icons';
import { DebouncedSearchField } from '../../../commonComponents/DebouncedSearchField';

/**
 * The user lists' filter fields: free-text search, phone search, and whichever
 * extra fields the list passes in as `CustomFilters`. Rendered as a fragment —
 * ListPage's `filters` slot supplies the card and the grid.
 */
export const Filters = ({ filter, handleFilterChange, CustomFilters }) => (
  <>
    <DebouncedSearchField
      label="Search"
      value={filter?.searchText}
      onChange={(value) => handleFilterChange('searchText', value)}
    />

    <DebouncedSearchField
      label="Phone search"
      placeholder="Phone Search"
      type="tel"
      icon={<OutlinePhoneIcon aria-hidden className="size-5" />}
      value={filter?.phone}
      onChange={(value) => handleFilterChange('phone', value)}
    />

    <CustomFilters filter={filter} handleFilterChange={handleFilterChange} />
  </>
);
